import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [sent, setSent] = useState(false);

  const handleSubmit = () => {
    setSent(true);
    setTimeout(() => setSent(false), 3000);
  };

  const methods = [
    { icon: '🖥️', label: 'پنل مشتریان', value: 'hub.afracell.com', link: 'https://hub.afracell.com' },
    { icon: '📧', label: 'ایمیل', value: 'info@afracell.com', link: 'mailto:info@afracell.com' },
    { icon: '✈️', label: 'تلگرام', value: '@afracell', link: 'https://t.me/afracell' },
  ];

  return (
    <section className="contact-sec" id="contact">
      <div className="wrap">
        <div className="contact-grid">
          <div>
            <span className="sec-tag">تماس با ما</span>
            <h2 className="sec-h">آماده‌ایم<br />کمکتان کنیم</h2>
            <p className="sec-p">مشاوره رایگان، استعلام قیمت یا سفارش سرویس — از یکی از روش‌های زیر با ما در تماس باشید.</p>
            <div className="contact-methods">
              {methods.map((m, i) => (
                <a key={i} href={m.link} className="cmethod" target="_blank" rel="noopener noreferrer">
                  <span className="cico">{m.icon}</span>
                  <div>
                    <strong>{m.label}</strong>
                    <span>{m.value}</span>
                  </div>
                </a>
              ))}
            </div>
          </div>
          <div className="form-box">
            <h3>ارسال پیام مستقیم</h3>
            <div className="fform">
              <input type="text" className="finput" placeholder="نام و نام خانوادگی" />
              <input type="email" className="finput" placeholder="ایمیل" />
              <input type="tel" className="finput" placeholder="شماره تماس" />
              <textarea className="ftarea" rows="4" placeholder="توضیح نیاز شما..."></textarea>
              <button className={`fsubmit ${sent ? 'sent' : ''}`} onClick={handleSubmit}>
                {sent ? '✅ پیام ارسال شد!' : 'ارسال پیام'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
